import { geohashForLocation, geohashQueryBounds, distanceBetween, } from 'geofire-common';
export function geohashFor(location) {
    return geohashForLocation([location.lat, location.lng]);
}
export function geohashBoundsForRadius(center, radiusKm) {
    const radiusM = radiusKm * 1000;
    return geohashQueryBounds([center.lat, center.lng], radiusM);
}
export function distanceKm(a, b) {
    return distanceBetween([a.lat, a.lng], [b.lat, b.lng]);
}
//# sourceMappingURL=geohash.js.map